import InfluencerRequestsScreen from './InfluencerRequestsScreen';

export default InfluencerRequestsScreen;
